// Depends
import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, meta('Meus Médicos', true, 'guest'))
]

export default subGroup('/patient/favorite-list', routes)



// WEBPACK FOOTER //
// ./src/app/patient/favorite-list/routes.js